import ScheduleUpdatesPage from './ScheduleUpdatesPage';

export default ScheduleUpdatesPage;
